// extracted by mini-css-extract-plugin
export var formContainer = "_lg-0";
export var message = "_lg-1";